var app = angular.module('leonardo');

var JWTConfig = function ($httpProvider, jwtInterceptorProvider) {
  jwtInterceptorProvider.authPrefix = 'jwt ';
  jwtInterceptorProvider.tokenGetter = function () {
    return localStorage.getItem('jwt_token');
  };
  $httpProvider.interceptors.push('jwtInterceptor');
  $httpProvider.interceptors.push('HttpInterceptor');
};

app.config(['$httpProvider', 'jwtInterceptorProvider', JWTConfig]);